import React from 'react';
import {
  Box, Container, Typography, Stack,
} from '@mui/material';
import TripReviewGiftForm from '../../components/trip-review-gift-form';

const TripReviewGiftFormView = () => (
  <Container maxWidth="md" sx={{ my: 2.75 }}>
    <Box
      sx={{
        py: {
          desktop: 6,
          mobile: 3,
        },
      }}
    >
      <Stack spacing={2}>
        <Typography variant="h2">Where should we send your free gift?</Typography>
        <TripReviewGiftForm />
      </Stack>
    </Box>
  </Container>
);

export default TripReviewGiftFormView;
